export const downloadFile = (fileName: string, encodedUri: string) => {
    const downloadLink = document.createElement('a');
    downloadLink.setAttribute('href', encodedUri);
    downloadLink.setAttribute('download', fileName);

    document.body.appendChild(downloadLink);
    downloadLink.click();
};
